﻿import React, { useState, useMemo, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import {
    Module_View_Toggler_Props,
    Module_View_Toggler_Settings
} from '@Util/Types';

export default function Module_View_Toggler({ module_one_settings, module_two_settings, module_one, module_two, default_module }: Module_View_Toggler_Props): JSX.Element {
    const [active_module, set_active_module] = useState<0 | 1>(default_module);

    useEffect(() => {
        if (isMobile) {
            set_active_module(1);
        } else {
            set_active_module(default_module);
        }
    }, [default_module]);

    const generate_toggler_button = (button_settings: Module_View_Toggler_Settings): JSX.Element => (
        <button
            type="button"
            className="Button Button_Icon"
            aria-label={button_settings.name}
            title={button_settings.name}
            onClick={() => set_active_module(button_settings.module_identifier)}
            aria-expanded={active_module === button_settings.module_identifier}
        >
            {button_settings.icon}
        </button>
    );

    const module_one_button: JSX.Element = useMemo(() => generate_toggler_button(module_one_settings), [module_one_settings, active_module]);
    const module_two_button: JSX.Element = useMemo(() => generate_toggler_button(module_two_settings), [module_two_settings, active_module]);

    return (
        <section className="Module_View">
            <div className="Module_View_Togglers">
                {module_one_button}
                {module_two_button}
            </div>
            {
                active_module === 0 ?
                    module_one :
                    module_two
            }
        </section>
    );
}